import { mutationTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'

export const state = () => {
  let newsTickerDismissed = false
  if (typeof window !== 'undefined' && window.localStorage) {
    newsTickerDismissed = window.localStorage.getItem('news-ticker-dismissed') === 'true'
  }

  return {
    activationPopupPending: true,
    newsTickerDismissed
  }
}

export const mutations = mutationTree(state, {
  setState: (state, payload: any) => {
    setState(state, payload)
    if (payload.stateName === 'newsTickerDismissed' && typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem('news-ticker-dismissed', payload.data ? 'true' : 'false')
    }
  }
})
